import { SectionHeading, UserGeneratedHtml } from '@atlassian/mpac-ui';
import React from 'react';
import { TEST_ID } from "../../../../../constants";
import Section from "../../../../Section";
const MoreDetails = ({
  showHeading,
  moreDetails
}) => /*#__PURE__*/React.createElement(Section, null, showHeading && /*#__PURE__*/React.createElement(SectionHeading, null, "More details"), /*#__PURE__*/React.createElement(UserGeneratedHtml, {
  dangerousHtml: moreDetails,
  "data-testid": TEST_ID.OVERVIEW_TAB_MORE_DETAILS_CONTENT
}));
MoreDetails.defaultProps = {
  showHeading: true
};
export default MoreDetails;